import { createRouter, createWebHistory } from 'vue-router';
import EventBus from '@/utils/EventBus.js';
import adminRoutes from '@/admin/router/index.js';
import store from '@/store/index.js';
import RootView from '@/views/RootView.vue';
import NotAvailableStub from '@/components/UI/NotAvailableStub.vue';

const router = createRouter({
    history: createWebHistory(),
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            component: RootView,
            children: adminRoutes,
        },
        {
            path: '/not-available',
            name: 'NotAvailable',
            component: NotAvailableStub,
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: {
                name: 'AdminProjectsList',
            },
        },
    ],
    scrollBehavior(to) {
        if (to.hash) {
            return {
                el: to.hash,
            };
        }
    },
});

router.beforeEach((to, from, next) => {
    store.dispatch('globals/setPreviousPageRoute', from);

    EventBus.$emit('route:change', to, from);

    return next();
});

export default router;
